import type { FunctionComponent, } from "react"
import styled from "styled-components"
import { Typography, type Variant } from "@bracket/ui"
import type { WEIString, } from "@bracket/types";

//@ts-ignore - remove if props added
export declare type BrktValueProps = {
	value: WEIString;
	variant?: Variant;
	precision?: number;
	highlight?: string;
	color?: string;
};


export const BrktValue: FunctionComponent<BrktValueProps> = ({
	value,
	variant = "p",
	precision = 5,
	highlight,
	color,
}) => {


	const formatted = (): string => {
		if(value === "invalid") {
			return "invalid";
		}
		try {
			return `${(Number(BigInt(value.toString().split(".")[0])) / 1e18).toFixed(precision)} brkt`;
		}
		catch(err) {
			return "invalid";
		}
	}

	return (
		<Brace>
			<Typography variant={variant} color={color}>{formatted()}</Typography>
		</Brace>
	);

}


const Brace = styled.div`

`
